<template>
    <div>
        <component v-for="(button,index) in buttons" :is="button._component" :button="button" :key="index" :step="step"></component>
    </div>
</template>

<script>
import mixin from "../../../travel_step_mixin";
import {Button} from "../../../../../../models/fields/Button";

export default {
    mixins: [mixin],
    data() {
        return {
            field_name:'optin_iban',
            buttons:[
                new Button('Bevestigen', 1).customClass({
                    'choice-button' : false,
                    'button': true,
                    'next-button': true,
                    'is-primary': true
                }),
            ]
        }
    },
    created() {
        this.step._field_name = this.field_name;
    }
}
</script>
